<template>
  <div class="index">
    <div class="row" style="padding-top: 2rem">
      <div class="col-5">
        <img src="../../static/img/ymzs.png" style="float: right;max-width: 100%;"/>
      </div>
      <div class="col-6">
        <div style="margin-top: 10%"></div>
        <div style="height: 60%;">
          <!-- <p class="content_1"><strong>亲亲，让生活不再孤单。</strong></p>
          <br/>
          <p class="content_2" :style="{fontSize : 0.5*windowWidth/100+'px' }">不知道和谁吐露心声，找不到可以聊天的人？那就来有你吧！在这里，可以通过文字，语音和视频找到与你志趣相投聊得来的人。</p>
          <br/>
          <p class="content_2">遇到有缘的人就主动和TA搭讪吧，别错过了一个结交知心朋友的机会。</p> -->
          <img src="../../static/img/content.png" style=" float: left;max-width: 100%;"/>
        </div>
        <div class="row" style="padding-top: 10%;">
          <div class="col-4" >
            <a href="https://fdajkwhin.wanjiavip.cn/apkerliao%2Fapp-YN_BD-release.apk">
              <img src="../../static/img/android.png" style="width: 100%;"/>
            </a>
          </div>
          <div class="col-4" >
            <a href="https://fdajkwhin.wanjiavip.cn/apkerliao%2Fapp-YN_BD-release.apk">
              <img src="../../static/img/ios.png" onclick="" style="width: 100%;"/>
            </a>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      data: 1,
      windowWidth: 1920
    }
  },
  mounted () {
    this.windowWidth = document.body.clientWidth
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.content_1 {
  font-size: calc(60vw * 100 / 1920);
  color: #333;
  float: left;
  text-align: left;
}
.content_2 {
  color: #555550;
  float: left;
  padding-top: 3%;
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue